import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchTaskGroups = ({ projectId, offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'task_groups',
        params: {
            project_id: projectId,
            offset,
            limit
        }
    })
    .then(response => validateResponse(response, 'items').data)
    .catch(handleServerError);
}

export const createTaskGroup = ({ project, name, order }) => {
    return AjaxService({
        method: 'post',
        url: 'task_groups',
        data: {
            project_id: project,
            name,
            order: order === Number.POSITIVE_INFINITY ? undefined : order
        }
    })
    .then(response => validateResponse(response, 'task_group').data.task_group)
    .catch(handleServerError);
}

export const fetchTaskGroup = taskGroupId => {
    return AjaxService({
        method: 'get',
        url: `task_groups/${taskGroupId}`
    })
    .then(response => response.data);
}

export const updateTaskGroup = (taskGroupId, { name, color, order, milestone }) => {
    return AjaxService({
        method: 'put',
        url: `task_groups/${taskGroupId}`,
        data: {
            name,
            color,
            order,
            milestone_id: milestone
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeTaskGroup = taskGroupId => {
    return AjaxService({
        method: 'delete',
        url: `task_groups/${taskGroupId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const assignUsers = (taskGroupId, assignees) => {
    return AjaxService({
        method: 'put',
        url: `task_groups/${taskGroupId}/assignees`,
        data: {
            assignees
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const unassignUsers = (taskGroupId, assignees) => {
    return AjaxService({
        method: 'delete',
        url: `task_groups/${taskGroupId}/assignees`,
        data: {
            assignees
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const moveAllTaskGroupTasks = (sourceTaskGroupId, targetTaskGroupId) => {
    return AjaxService({
        method: 'post',
        url: `task_groups/${sourceTaskGroupId}/move`,
        data: {
            target: targetTaskGroupId
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const duplicateTaskGroup = taskGroupId => {
    return AjaxService({
        method: 'post',
        url: `task_groups/${taskGroupId}/clone`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const setVisibility = (taskGroupId, visible, roles) => {
    return AjaxService({
        method: 'post',
        url: `task_groups/${taskGroupId}/${visible ? 'reveal' : 'hide'}`,
        data: { roles }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const tieToMilestone = taskGroupId => {
    return AjaxService({
        method: 'put',
        url: `task_groups/${taskGroupId}/to-milestone`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const untieFromMilestone = taskGroupId => {
    return AjaxService({
        method: 'delete',
        url: `task_groups/${taskGroupId}/to-milestone`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
